var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.dependant_leave_area
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "leaveArea[own_room][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.own_room_kitchen_surface,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                    }
                  },
                  model: {
                    value: _vm.leaveArea["own_room"].surface,
                    callback: function($$v) {
                      _vm.$set(_vm.leaveArea["own_room"], "surface", $$v)
                    },
                    expression: "leaveArea['own_room'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "leaveArea[common_area][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_area_with_central_heating,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                    }
                  },
                  model: {
                    value: _vm.leaveArea["common_area"].surface,
                    callback: function($$v) {
                      _vm.$set(_vm.leaveArea["common_area"], "surface", $$v)
                    },
                    expression: "leaveArea['common_area'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "leaveArea[number_of_residents]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.number_of_residents
                },
                on: {
                  input: function($event) {
                    return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                  }
                },
                model: {
                  value: _vm.leaveArea["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.leaveArea, "number_of_residents", $$v)
                  },
                  expression: "leaveArea['number_of_residents']"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "leaveArea[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.leave_area
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.leaveArea.total,
                  callback: function($$v) {
                    _vm.$set(_vm.leaveArea, "total", $$v)
                  },
                  expression: "leaveArea.total"
                }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.heated_private_rooms
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("theme-radios", {
            attrs: {
              columnDirection: true,
              label: "",
              name: "heating[type]",
              options: {
                "0":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.no_heating_or_electric,
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.gas_heater,
                "2":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.central_heating
              }
            },
            on: { input: _vm.countHeatingPoints },
            model: {
              value: _vm.heating.type.value,
              callback: function($$v) {
                _vm.$set(_vm.heating.type, "value", $$v)
              },
              expression: "heating.type.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.heating.type.value == 2
        ? _c("div", { staticClass: "mb-10" }, [
            _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-12 mb-5" },
              [
                _c(
                  "div",
                  { staticClass: "col-span-4" },
                  [
                    _c("theme-numeric", {
                      attrs: {
                        name: "heating[central_heating]",
                        label:
                          _vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.central_heating_surface
                      },
                      on: { input: _vm.countHeatingPoints },
                      model: {
                        value: _vm.heating.central_heating.value,
                        callback: function($$v) {
                          _vm.$set(_vm.heating.central_heating, "value", $$v)
                        },
                        expression: "heating.central_heating.value"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-5" },
              [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "heating[thermostat]",
                    value: "0"
                  }
                }),
                _vm._v(" "),
                _c("theme-checkboxes", {
                  attrs: {
                    id: "heatingThermostat",
                    label: "",
                    "is-single-checkbox": true,
                    name: "heating[thermostat]",
                    options: {
                      "1":
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.thermostat_buttons) +
                        " " +
                        (_vm.heating.thermostat.total || "")
                    }
                  },
                  on: { input: _vm.countHeatingPoints },
                  model: {
                    value: _vm.heating.thermostat.value,
                    callback: function($$v) {
                      _vm.$set(_vm.heating.thermostat, "value", $$v)
                    },
                    expression: "heating.thermostat.value"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                name: "heating[total]",
                label: _vm.totalLabel(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.heated_private_rooms
                ),
                isReadonly: true
              },
              model: {
                value: _vm.heating.total,
                callback: function($$v) {
                  _vm.$set(_vm.heating, "total", $$v)
                },
                expression: "heating.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.kitchen_facilities_sanitary
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-5 lg:gap-y-8 mb-10"
        },
        [
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.kitchen
                    ) +
                    "\n          "
                ),
                _vm.kitchenFacilities.kitchen.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchenFacilities.kitchen.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen_facilities[kitchen]",
                  options: _vm.kitchenOptions
                },
                on: { input: _vm.countKitchenFacilitiesPoints },
                model: {
                  value: _vm.kitchenFacilities.kitchen.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchenFacilities.kitchen, "value", $$v)
                  },
                  expression: "kitchenFacilities.kitchen.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.wc
                    ) +
                    "\n          "
                ),
                _vm.kitchenFacilities.wc.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchenFacilities.wc.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen_facilities[wc]",
                  options: _vm.wcOptions
                },
                on: { input: _vm.countKitchenFacilitiesPoints },
                model: {
                  value: _vm.kitchenFacilities.wc.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchenFacilities.wc, "value", $$v)
                  },
                  expression: "kitchenFacilities.wc.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.bath_shower
                    ) +
                    "\n          "
                ),
                _vm.kitchenFacilities.bath_shower.value
                  ? _c("strong", [
                      _vm._v(
                        _vm._s(_vm.kitchenFacilities.bath_shower.total || "")
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen_facilities[bath_shower]",
                  options: _vm.bathShowerOptions
                },
                on: { input: _vm.countKitchenFacilitiesPoints },
                model: {
                  value: _vm.kitchenFacilities.bath_shower.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchenFacilities.bath_shower, "value", $$v)
                  },
                  expression: "kitchenFacilities.bath_shower.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.washbasin
                    ) +
                    "\n          "
                ),
                _vm.kitchenFacilities.washbasin.value
                  ? _c("strong", [
                      _vm._v(
                        _vm._s(_vm.kitchenFacilities.washbasin.total || "")
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen_facilities[washbasin]",
                  options: _vm.washbasinOptions
                },
                on: { input: _vm.countKitchenFacilitiesPoints },
                model: {
                  value: _vm.kitchenFacilities.washbasin.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchenFacilities.washbasin, "value", $$v)
                  },
                  expression: "kitchenFacilities.washbasin.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                name: "kitchen_facilities[total]",
                label: _vm.totalLabel(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.kitchen_facilities_sanitary
                ),
                isReadonly: true
              },
              model: {
                value: _vm.kitchenFacilities.total,
                callback: function($$v) {
                  _vm.$set(_vm.kitchenFacilities, "total", $$v)
                },
                expression: "kitchenFacilities.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.extra_points
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-12 gap-x-5 gap-y-5 lg:gap-y-8 mb-10"
        },
        [
          _c(
            "div",
            { staticClass: "col-span-6" },
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.outdoor_space
                    ) +
                    "\n          "
                ),
                _vm.extraPoints.outdoor_space.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.extraPoints.outdoor_space.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "extra_points[outdoor_space]",
                  options: _vm.outdoorSpaceOptions
                },
                on: { input: _vm.countExtraPoints },
                model: {
                  value: _vm.extraPoints.outdoor_space.value,
                  callback: function($$v) {
                    _vm.$set(_vm.extraPoints.outdoor_space, "value", $$v)
                  },
                  expression: "extraPoints.outdoor_space.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-span-6" },
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.bicycle_shed
                    ) +
                    "\n          "
                ),
                _vm.extraPoints.bicycle_shed.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.extraPoints.bicycle_shed.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "extra_points[bicycle_shed]",
                  options: _vm.bicycleShedOptions
                },
                on: { input: _vm.countExtraPoints },
                model: {
                  value: _vm.extraPoints.bicycle_shed.value,
                  callback: function($$v) {
                    _vm.$set(_vm.extraPoints.bicycle_shed, "value", $$v)
                  },
                  expression: "extraPoints.bicycle_shed.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "extra_points[national_monument]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "extraPointsNationalMonument",
              label: "",
              "is-single-checkbox": true,
              name: "extra_points[national_monument]",
              options: {
                "1":
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.is_national_monument) +
                  " " +
                  (_vm.extraPoints.national_monument.total || "")
              }
            },
            on: { input: _vm.countExtraPoints },
            model: {
              value: _vm.extraPoints.national_monument.value,
              callback: function($$v) {
                _vm.$set(_vm.extraPoints.national_monument, "value", $$v)
              },
              expression: "extraPoints.national_monument.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                name: "extra_points[total]",
                label: _vm.totalLabel(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.extra_points
                ),
                isReadonly: true
              },
              model: {
                value: _vm.extraPoints.total,
                callback: function($$v) {
                  _vm.$set(_vm.extraPoints, "total", $$v)
                },
                expression: "extraPoints.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calculate-price__form-section" },
      [
        _c("h2", { staticClass: "calculate-price__form-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.deduction_points
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.deductionOptions, function(deduction, index) {
          return _c("div", { staticClass: "mb-10" }, [
            index != "total"
              ? _c(
                  "div",
                  { key: index, staticClass: "mb-7" },
                  [
                    _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "deduction_points[" + index + "]",
                        value: "0"
                      }
                    }),
                    _vm._v(" "),
                    _c("theme-checkboxes", {
                      attrs: {
                        id: "deductionOptions" + index,
                        label: "",
                        "is-single-checkbox": true,
                        name: "deduction_points[" + index + "]",
                        options: {
                          "1":
                            (_vm.locales &&
                              _vm.locales.properties &&
                              _vm.locales.properties[index]) +
                            " " +
                            (_vm.deductionOptions[index].total || "")
                        }
                      },
                      on: { input: _vm.countDeductionPoints },
                      model: {
                        value: _vm.deductionOptions[index].value,
                        callback: function($$v) {
                          _vm.$set(_vm.deductionOptions[index], "value", $$v)
                        },
                        expression: "deductionOptions[index].value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "deduction_points[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.deduction_points_total
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.deductionOptions.total,
                  callback: function($$v) {
                    _vm.$set(_vm.deductionOptions, "total", $$v)
                  },
                  expression: "deductionOptions.total"
                }
              })
            ],
            1
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-bottom" }, [
      _c(
        "div",
        {
          staticClass:
            "default-content grid grid-cols-1 lg:grid-cols-12 items-center gap-1 lg:gap-5"
        },
        [
          _c("div", { staticClass: "col-span-2 hidden lg:block" }, [
            _c("h3", { staticClass: "calculate-price__form-bottom-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    this.locales &&
                      this.locales.common &&
                      this.locales.common.total
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lg:col-span-7" }, [
            _c("div", { staticClass: "grid grid-cols-2 items-center gap-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.properties &&
                            _vm.locales.properties.total_points
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.totalPoints || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: { name: "total", label: "", isReadonly: true },
                        model: {
                          value: _vm.totalPoints,
                          callback: function($$v) {
                            _vm.totalPoints = $$v
                          },
                          expression: "totalPoints"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.properties &&
                            _vm.locales.properties.max_basic_rent_price
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.price || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: { name: "price", label: "", isReadonly: true },
                        model: {
                          value: _vm.price,
                          callback: function($$v) {
                            _vm.price = $$v
                          },
                          expression: "price"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lg:col-span-3 grid grid-cols-2 items-center gap-5"
            },
            [
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.download_pdf
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit", name: "submit", value: "save" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.save
                      ) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d10db84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d10db84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DependantForm.vue
// module id = 765
// module chunks = 1